import teamsnapSdk from 'utils/teamsnapSdk';
import { addItems } from 'state/teamsnap/actions';

export const loadPlans = () => (dispatch, getState) => {
  dispatch(addItems({ items: teamsnapSdk().plans }));
};
